import {
  createEmptyContentSnapshotV2,
  parseContentSnapshotV2,
  type ContentSnapshotV2,
} from "../../runtime/content/ContentSnapshotV2";
import type { RuntimeContent } from "../../runtime/content/RuntimeContent";
import type { CharacterStudioContent, PrincessAppearanceSelection } from "../../shared/characters";

export class DraftRuntimeContent implements RuntimeContent {
  characterStudio?: CharacterStudioContent;
  princessAppearance?: PrincessAppearanceSelection;
  readonly previewWarnings: string[] = [];
  constructor(protected current: ContentSnapshotV2 = createEmptyContentSnapshotV2()) {
  }
  get snapshot() { return this.current; }
  protected setSnapshot(value: unknown) { this.current = parseContentSnapshotV2(value); }
  protected warnPreview(message: string) { this.previewWarnings.push(message); }
  protected setCharacterStudio(value: CharacterStudioContent, selection: PrincessAppearanceSelection) {
    this.characterStudio = value;
    this.princessAppearance = selection;
  }
  getAsset(id: string) { return this.snapshot.assets[id]; }
  getKnight(key: string) { return this.snapshot.core.knights[key]; }
  getBuilding(key: string) { return this.snapshot.core.buildings[key]; }
  getBondInteraction(key: string) { return this.snapshot.bonds[key]; }
  getPrincessCosmetic(key: string) { return this.snapshot.cosmetics[key]; }
  getEnemy(key: string) { return this.snapshot.enemies[key]; }
  getModifier(key: string) { return this.snapshot.modifiers[key]; }
  getCombatProfile(key: string) { return this.snapshot.combatProfiles[key]; }
  getRewardTable(key: string) { return this.snapshot.rewards[key]; }
  getMission(key: string) { return this.snapshot.missions[key]; }
  getUiDocument(key: string) { return this.snapshot.ui.documents[key]; }
  getUiElements(id: string) { return this.snapshot.ui.elementsByDocument[id] ?? []; }
}
